import { classNames } from '@commenda/utils';

type SegmentedControlOption = {
  label: string;
  value: string;
};

type SegmentedControlProps = {
  options: SegmentedControlOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
};

export const SegmentedControl = ({
  options,
  value,
  onChange,
  className = '',
}: SegmentedControlProps) => {
  return (
    <div
      className={classNames(
        'inline-flex border-[1.5px] border-border-primary rounded-md overflow-hidden bg-bg-subtle',
        className
      )}
    >
      {options.map((option) => {
        const isSelected = option.value === value;

        return (
          <button
            key={option.value}
            type="button"
            className={classNames(
              'px-2 py-1.5 txt-small-medium transition-colors',
              'border-r-[1.5px] border-border-primary last:border-0',
              isSelected
                ? 'bg-white text-text-primary txt-small-bold'
                : 'bg-transparent text-text-secondary hover:bg-bg-default'
            )}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
